var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataCollecting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:ibm-software-watsonx-data-structured-import"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.1875 75.5625H63.4434L70.9416 83.0897L66.8438 87.1875L52.3125 72.6562L66.8438 58.125L70.9416 62.2228L63.4434 69.75H87.1875V75.5625ZM11.625 69.75H46.5V75.5625H11.625C10.0834 75.5625 8.605 74.9501 7.51494 73.8601C6.42489 72.77 5.8125 71.2916 5.8125 69.75V11.625C5.8125 10.0834 6.42489 8.605 7.51494 7.51494C8.605 6.42489 10.0834 5.8125 11.625 5.8125H75.5625C77.1041 5.8125 78.5825 6.42489 79.6726 7.51494C80.7626 8.605 81.375 10.0834 81.375 11.625V52.3125H75.5625V26.1562H11.625V69.75ZM11.625 20.3438H75.5625V11.625H11.625V20.3438ZM17.4375 37.7812H31.9688V31.9688H17.4375V37.7812ZM37.7812 37.7812H52.3125V31.9688H37.7812V37.7812ZM17.4375 49.4062H31.9688V43.5938H17.4375V49.4062ZM37.7812 49.4062H52.3125V43.5938H37.7812V49.4062ZM17.4375 61.0312H31.9688V55.2188H17.4375V61.0312ZM37.7812 61.0312H52.3125V55.2188H37.7812V61.0312Z",
    fill: "var(--fill-0, #8E8E8E)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCollecting);
export default __webpack_public_path__ + "static/media/data-collecting.1410eb9ffeaaa25f89bd7a2148d67e8f.svg";
export { ForwardRef as ReactComponent };